import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MediaModule } from '@modules/media/media.module';
import { SectionModule } from '@modules/section/section.module';
import { SharedModule } from '@modules/shared/shared.module';
import { StreamPlayerModule } from '@modules/stream-player/stream-player.module';

import { MagazinePageComponent } from './magazine-page.component';
import { MagazinePageService } from './magazine-page.service';
import { MagazineRoutingModule } from './magazine-routing.module';
import { PageViewComponent } from './page-view.component';

@NgModule({
  imports: [
    CommonModule,
    MagazineRoutingModule,
    SharedModule,
    MediaModule,
    SectionModule,
    StreamPlayerModule,
    MagazinePageComponent,
    PageViewComponent,
  ],
  providers: [MagazinePageService],
})
export class MagazinePageModule {}
